import Image from 'next/image';

import {
  Landmark,
  ShieldCheck,
  Truck,
  Wrench,
} from '@holistic/components/icons';

const items = [
  { icon: Landmark, title: 'Bakanlık onaylı', description: 'yenileme merkezi' },
  { icon: Wrench, title: 'TSE standartlarında', description: 'operasyon' },
  { icon: Truck, title: 'Ücretsiz çift yönlü kargo' },
  { icon: ShieldCheck, title: 'Garantili onarım' },
];

/**
 * İlk adımın yan sütunu. Henüz seçim yapılmadığı için "Seçimleriniz" kartı
 * yerine güvence paneli gösterilir.
 */
const TrustPanel = () => (
  <div className="bg-primary/5 overflow-hidden rounded-2xl">
    <div className="space-y-5 p-6">
      <div className="space-y-2">
        <p className="text-primary text-sm font-bold tracking-[0.12em] uppercase">
          Yeniden.co güvencesiyle
        </p>
        <p className="text-2xl font-bold tracking-tight text-gray-900 md:text-[2rem]">
          Cihazınız
          <br />
          emin ellerde.
        </p>
      </div>

      <ul className="space-y-4">
        {items.map(({ icon: Icon, title, description }) => (
          <li key={title} className="flex items-center gap-3">
            <span className="bg-primary/10 flex size-10 shrink-0 items-center justify-center rounded-xl">
              <Icon className="text-primary size-4" />
            </span>
            <span className="text-base leading-snug">
              <span className="block font-medium text-gray-900">{title}</span>
              {description && (
                <span className="text-gray-500">{description}</span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>

    <div className="relative h-44 w-full">
      <Image
        src="/about/onarim-detay.webp"
        alt="Teknisyen cihaz onarırken"
        fill
        sizes="(min-width: 768px) 320px, 100vw"
        className="object-cover"
      />
    </div>
  </div>
);

export default TrustPanel;
